import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {ListaDeCentros} from '../centro-de-votacion/lista-de-centros';
import { Lista } from '../proyectos-aceptados/lista-de-proyectos';



function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const ProyectoParticipativoTabs = ()=> {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Proyectos (Distrito 1)" {...a11yProps(0)} style={{fontWeight: 'bold'}}/>
          <Tab label="Casillas por Distrito" {...a11yProps(1)} style={{fontWeight: 'bold'}}/>
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Lista />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
         <ListaDeCentros />
      </CustomTabPanel>
    </Box>
  );
}